<template>
  <section class="ogpo" v-if="!loaded">
    <template v-if="!insurerBmgError.iin">
      <div v-if="getUser">
        <alert-main v-if="!getUser.hasTerminal" title="У вас не настроен терминал." description="Пожалуйста, обратитесь к ответственному бухгалтеру. <br/>Если терминал настроен, необходимо обновить токен или вновь авторизоваться."/>
      </div>
      <div v-if="policy.residentRulesError"
           class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-10 align-items-center">
        <i class="ki-duotone ki-message-text-2 fs-2hx text-light me-4 mb-5 mb-sm-0">
          <i class="ki-duotone ki-notification-bing fs-2hx text-light me-4 mb-5 mb-sm-0">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
        </i>
        <div class="d-flex flex-column text-light pe-0 pe-sm-10">
          <h4 class="mb-2 text-light">Ошибка</h4>
          <span>
            {{ this.policy.residentRulesError }}
          </span>
        </div>
      </div>
      <div v-if="(!validateImages && policy.hasPaid) || (!validateDriversLicense && policy.hasCalc)" class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row w-100 p-5 mb-10 align-items-center">
        <i class="ki-duotone ki-message-text-2 fs-2hx text-light me-4 mb-5 mb-sm-0">
          <i class="ki-duotone ki-notification-bing fs-2hx text-light me-4 mb-5 mb-sm-0">
            <span class="path1"></span><span class="path2"></span><span class="path3"></span>
          </i>
        </i>
        <div class="d-flex flex-column text-light pe-0 pe-sm-10">
          <h4 class="mb-2 text-light">Ошибка</h4>
          <div v-if="!validateImages && policy.hasPaid">
            Прикрепите все документы
          </div>
          <div v-if="!validateDriversLicense && policy.hasVerify">
            Прикрепите водительское удостоверение
          </div>
        </div>
      </div>
      <section v-if="ticket === null">
        <template v-if="!policy.product_type">
          <div class="row">
            <div class="col-xl-6 col-xxl-6">
              <div @click="setProduct(1)" class="card mb-5 hover-elevate-up shadow-sm parent-hover cursor-pointer">
                <div class="card-body d-flex align-items-center">
                  <i class="ki-duotone ki-file fs-1 parent-hover-primary"><span class="path1"></span><span class="path2"></span></i>
                  <span class="ms-4 text-gray-700 parent-hover-primary fs-6 fw-bold">ОГПО ВТС</span>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-xxl-6">
              <div @click="setProduct(2)" class="card mb-5 hover-elevate-up shadow-sm parent-hover cursor-pointer">
                <div class="card-body d-flex align-items-center">
                  <i class="ki-duotone ki-file fs-1 parent-hover-primary"><span class="path1"></span><span class="path2"></span></i>
                  <span class="ms-4 text-gray-700 parent-hover-primary fs-6 fw-bold">Временный въезд</span>
                </div>
              </div>
            </div>
<!--            <div class="col-xl-6 col-xxl-4">-->
<!--              <div @click="setProduct(3)" class="card mb-5 hover-elevate-up shadow-sm parent-hover cursor-pointer">-->
<!--                <div class="card-body d-flex align-items-center">-->
<!--                  <i class="ki-duotone ki-file fs-1 parent-hover-primary"><span class="path1"></span><span class="path2"></span></i>-->
<!--                  <span class="ms-4 text-gray-700 parent-hover-primary fs-6 fw-bold">Транзит</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </template>
        <template v-else>
          <template v-if="policy.product_type === 1">
            <div class="h-250px bg-white text-primary d-flex justify-content-center align-items-center rounded fs-5">
              Услуга ОГПО ВТС для резидентов в данный момент недоступна.
            </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-xl-6 col-xxl-4">
                <section class="insurer mb-5">
                  <h6 class="mb-5 text-gray-700">Страхователь</h6>
                  <customer-card
                      v-if="this.policy.insurer"
                      :changeDisabled="this.changeDisabled"
                      :client="this.policy.insurer"
                      :beingVerify="false"
                      :key-item="0"
                      :has-paid="policy.hasPaid"
                      :module="OsgpoModule"
                      :class="(this.policy.insurer.podft && !this.policy.insurer.podft.success) ? 'invalid' : ''">
                    <template v-slot:change>
                    <span v-if="this.policy.insurer.podft.success || this.policy.insurer.podft.canEdit"
                          class="edit-item"
                          @click="setClient(1, this.policy.insurer)">
                      <i class="ki-outline ki-notepad-edit fs-3"></i>
                    </span>
                      <template v-else>
                      <span v-if="this.policy.insurer.podft.setDocument"
                            class="add-item"
                            @click="uploadData(this.policy.insurer.podft.id, this.policy.insurer.client.iin, 0, 0)">
                        <i class="ki-outline ki-message-add fs-3"></i>
                      </span>
                      </template>
                    </template>
                    <template v-slot:footer>
                      <div v-if="this.policy.insurer && !this.policy.insurer.filter.person" class="p-1 m-2 border rounded product-documents text-start">
                        <div class="p-1 border-bottom">
                          <div class="fs-8 text-gray-600 required-before">Руководитель</div>
                          <div v-if="policy.insurer.leader && policy.insurer.leader.title">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="fs-7 text-gray-800 ms-2" v-html="policy.insurer.leader.title"></div>
                              <div v-if="policy.insurer.leader.added && !changeDisabled" class="card_change h-15px"
                                   @click="deleteChief(null, true)">
                                <span class="delete-item h-15px"><i class="ki-outline ki-cross-square fs-3"></i></span>
                              </div>
                            </div>
                          </div>
                          <span v-else-if="!changeDisabled" class="fs-7 text-primary cursor-pointer ms-2"
                                @click="setChief(true)">
                          Добавить
                        </span>
                        </div>
                        <div class="p-1">
                          <div class="fs-8 text-gray-600 required-before">Бенефициарный собственник</div>
                          <template v-if="policy.insurer.beneficiaries && policy.insurer.beneficiaries.length">
                            <div class="px-2 py-1 border rounded mb-2" v-for="(item, key) in policy.insurer.beneficiaries" :key="key">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="fs-7 text-gray-800 my-1 ms-2" v-html="item.title"></div>
                                <div v-if="item.added && !changeDisabled" class="card_change h-15px" @click="deleteChief(key)">
                                  <span class="delete-item h-15px"><i class="ki-outline ki-cross-square fs-3"></i></span>
                                </div>
                              </div>
                            </div>
                          </template>
                          <span v-if="!changeDisabled" class="fs-7 text-primary cursor-pointer ms-2" @click="setChief(false)">Добавить</span>
                        </div>
                      </div>
                      <div v-if="policy.insurer.podft.success && !policy.insurer.filter.resident && policy.insurer.filter.person" class="p-2 m-2 border rounded product-documents">
                        <document-uploads
                            :type="1"
                            :ulid="policy.number"
                            :title="policy.insurer.client.title"
                            :iin="policy.insurer.filter.resident ? policy.insurer.client.iin : null"
                            :data="policy.insurer.images ? policy.insurer.images.filter(item => item.type_id === '00001') : null"
                            :kind="1"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                        <document-uploads
                            :type="2"
                            :ulid="policy.number"
                            :title="policy.insurer.client.title"
                            :iin="policy.insurer.filter.resident ? policy.insurer.client.iin : null"
                            :data="policy.insurer.images ? policy.insurer.images.filter(item => item.type_id === '00028') : null"
                            :kind="1"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                        <document-uploads
                            v-if="policy.insurer.driver.pensioner"
                            :type="3"
                            :ulid="policy.number"
                            :title="policy.insurer.client.title"
                            :iin="policy.insurer.filter.resident ? policy.insurer.client.iin : null"
                            :data="policy.insurer.images ? policy.insurer.images.filter(item => item.type_id === '00033') : null"
                            :kind="1"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                      </div>
                      <div v-if="policy.insuredsShow && !changeDisabled" class="border-top pt-4 pb-4">
                        <checkbox-field
                            v-model="policy.isDrive"
                            placeholder="Будет управлять авто"
                            id="is.driver"
                            class="form-check-sm justify-content-center"
                        />
                      </div>
                    </template>
                  </customer-card>
                  <div
                      v-if="!this.policy.insurer && !this.changeDisabled"
                      @click="isInsurer = true; setClient(1)"
                      class="empty-card opacity-75">
                    <span class="fs-7 text-primary">Добавить</span>
                  </div>
                </section>
              </div>
              <div class="col-xl-6 col-xxl-4" :class="!this.policy.insurer ? 'opacity-50' : ''">
                <h6 class="mb-5 text-gray-700">Застрахованный</h6>
                <template v-if="this.policy.insureds.length">
                  <customer-card
                      v-for="(item, key) in this.policy.insureds"
                      :key="key"
                      :changeDisabled="this.changeDisabled"
                      :key-item="key"
                      :client="item"
                      :has-paid="policy.hasPaid"
                      :module="OsgpoModule"
                      :class="errorClientKey.includes(key.toString()) || (item.podft && !item.podft.success) ? 'invalid' : ''">
                    <template v-slot:change v-if="!changeDisabled">
                      <template v-if="!(item.podft && !item.podft.success)">
                      <span class="edit-item"
                            @click="setClient(2, item, key)">
                        <i class="ki-outline ki-notepad-edit fs-3"></i>
                      </span>
                      </template>
                      <template v-else>
                      <span v-if="item.podft.setDocument"
                            class="add-item"
                            @click="uploadData(this.policy.insureds[key].podft.id, this.policy.insureds[key].client.iin, 1, key)">
                        <i class="ki-outline ki-message-add fs-3"></i>
                      </span>
                      </template>
                      <span class="delete-item" @click="deleteClient(key)">
                      <i class="ki-outline ki-cross-square fs-3"></i>
                    </span>
                    </template>
                    <template v-slot:footer>
                      <div v-if="this.policy.insureds[key].filter.person" class="p-1 m-2 border rounded product-documents text-start">
                        <div  class="p-2">
                          <div class="fs-8 text-gray-600 required">Водительское удостоверение</div>
                          <div v-if="policy.insureds[key].driver.document && policy.insureds[key].driver.document.number"
                               class="d-flex justify-content-between align-items-center">
                            <div class="fs-7 text-gray-800" v-html="policy.insureds[key].driver.document.number"></div>
                            <div v-if="!changeDisabled" class="card_change"
                                 @click="deleteDriversLicense(policy.insureds[key].document.number)">
                              <span class="delete-item"><i class="ki-outline ki-cross-square fs-3"></i></span>
                            </div>
                          </div>
                          <span v-else-if="!changeDisabled" class="fs-7 text-primary cursor-pointer"
                                @click="setDriversLicense(policy.insureds[key].document.number, policy.insureds[key].client.iin, policy.insureds[key].filter.resident)">Добавить</span>
                        </div>
                      </div>
                      <div v-if="policy.insureds[key].podft.success && !policy.insureds[key].filter.resident && policy.insureds[key].filter.person" class="p-2 m-2 border rounded product-documents">
                        <document-uploads
                            :type="1"
                            :ulid="policy.number"
                            :title="policy.insureds[key].client.title"
                            :iin="policy.insureds[key].filter.resident ? policy.insureds[key].client.iin : null"
                            :data="policy.insureds[key].images ? policy.insureds[key].images.filter(item => item.type_id === '00001') : null"
                            :kind="2"
                            :item-key="parseInt(key)"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                        <document-uploads
                            :type="2"
                            :ulid="policy.number"
                            :title="policy.insureds[key].client.title"
                            :iin="policy.insureds[key].filter.resident ? policy.insureds[key].client.iin : null"
                            :data="policy.insureds[key].images ? policy.insureds[key].images.filter(item => item.type_id === '00028') : null"
                            :kind="2"
                            :item-key="parseInt(key)"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                        <document-uploads
                            v-if="policy.insureds[key].driver.pensioner"
                            :type="3"
                            :ulid="policy.number"
                            :title="policy.insureds[key].client.title"
                            :iin="policy.insureds[key].filter.resident ? policy.insureds[key].client.iin : null"
                            :data="policy.insureds[key].images ? policy.insureds[key].images.filter(item => item.type_id === '00033') : null"
                            :kind="2"
                            :item-key="parseInt(key)"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                      </div>
                    </template>
                  </customer-card>
                </template>
                <template v-if="!this.changeDisabled">
                  <div v-if="policy.insuredsShow && this.policy.insurer"
                       class="empty-card"
                       @click="isInsurer = false; setClient(2)">
                    <span class="fs-7 text-primary">Добавить</span>
                  </div>
                  <template v-else>
                    <div v-if="policy.insuredsShow" class="empty-card">
                      <span class="fs-7 text-primary">Добавить</span>
                    </div>
                  </template>
                </template>
              </div>
              <div class="col-xl-6 col-xxl-4" :class="this.policy.insureds.length === 0 ? 'opacity-50' : ''">
                <h6 class="mb-5 text-gray-700">Авто</h6>
                <template v-if="this.policy.vehicle.length">
                  <vehicle-card
                      v-for="(item, key) in this.policy.vehicle"
                      :key="key"
                      :changeDisabled="this.changeDisabled"
                      @deleteVehicle="deleteVehicle(key)"
                      :is-deleted="true"
                      :vehicle="item"
                      :class="(item.podft && !item.podft.success) ? 'invalid' : ''">
                    <template v-slot:change v-if="!changeDisabled">
                      <template v-if="!(item.podft && !item.podft.success)">
                      <span class="edit-item"
                            @click="setChangedVehicle(key)">
                        <i class="ki-outline ki-notepad-edit fs-3"></i>
                      </span>
                      </template>
                      <template v-else>
                      <span v-if="item.podft.setDocument"
                            class="add-item"
                            @click="uploadData(this.policy.vehicle[key].podft.id, this.policy.vehicle[key].number ?? this.policy.vehicle[key].vin, 2, key)">
                        <i class="ki-outline ki-message-add fs-3"></i>
                      </span>
                      </template>
                      <span class="delete-item" @click="deleteVehicle(key)">
                      <i class="ki-outline ki-cross-square fs-3"></i>
                    </span>
                    </template>
                    <template v-slot:footer>
                      <div v-if="this.policy.vehicle[key].podft.success && !this.policy.vehicle[key].verify" class="p-2 m-2 border rounded product-documents">
                        <document-uploads
                            :type="4"
                            :ulid="policy.number"
                            :title="this.policy.vehicle[key].number"
                            :iin="this.policy.vehicle[key].number"
                            :data="this.policy.vehicle[key].images ? this.policy.vehicle[key].images.filter(item => item.type_id === '00021') : null"
                            :kind="3"
                            :item-key="parseInt(key)"
                            @add-document="addDocument"
                            @delete-document="deleteDocument"/>
                      </div>
                    </template>
                  </vehicle-card>
                </template>
                <template v-if="!this.changeDisabled">
                  <div v-if="policy.vehicleShow && this.policy.insureds.length > 0"
                       class="empty-card"
                       @click="setChangedVehicle(null, true)">
                    <span class="fs-7 text-primary">Добавить</span>
                  </div>
                  <template v-else>
                    <div v-if="policy.vehicleShow"
                         class="empty-card">
                      <span class="fs-7 text-primary">Добавить</span>
                    </div>
                  </template>
                </template>
              </div>
            </div>
            <hr  v-if="policy.insurer && policy.insurer.hasOwnProperty('client')" class="text-primary opacity-20">
            <div v-if="policy.insurer && policy.insurer.hasOwnProperty('client')" class="row">
              <div class="col-xl-6 col-xxl-4">
                <h6 class="mb-5 text-gray-700">Договор</h6>
                <div class="pb-7" v-if="policy.hasPaid">
                  <div class="rounded border p-6 bg-white info-panel">
                    <div class="text-gray-500 fs-8 mb-1">Дата калькуляции: <span class="float-end" v-html="policy.calculationDate"></span></div>
                    <template v-if="policy.hasOwnProperty('refund') || policy.hasOwnProperty('add_payment')">
                      <div class="text-gray-500 fs-8 mb-1">Стоимость полиса:
                        <span class="float-end">{{policy.premium.toLocaleString('ru-RU')}} тг.</span>
                      </div>
                      <div class="text-gray-500 fs-8 mb-1">Возврат:
                        <span class="float-end">{{policy.refund.toLocaleString('ru-RU')}} тг.</span>
                      </div>
                    </template>
                    <div class="fw-bold" style="font-size: 20px">
                      Итого к оплате: <span class="float-end">
                  {{policy.hasOwnProperty('add_payment') ? policy.add_payment.toLocaleString('ru-RU') : policy.premium.toLocaleString('ru-RU')}} тг.
                </span>
                    </div>
                  </div>
                </div>
                <div class="pb-7">
                  <div class="rounded border p-6 bg-white info-panel">
                    <div class="row">
                      <div class="col-xxl-6 col-xl-12">
                        <date-field
                            v-model="policy.treaty.date"
                            :required="true"
                            :mb="5"
                            placeholder="Дата начала договора"
                            name="treaty_date"
                            id="treaty.date"
                        />
                      </div>
                      <div class="col-xxl-6 col-xl-12">
                        <select-field
                            v-if="this.policy.product_type === 1"
                            v-model="policy.treaty.term"
                            :options="{12:'12'}"
                            :required="true"
                            :mb="5"
                            placeholder="Срок (мес)"
                            name="treaty_term"
                            id="treaty.term"
                        />
                        <date-field
                            v-else-if="this.policy.product_type === 2"
                            v-model="policy.treaty.term"
                            :required="true"
                            :mb="5"
                            :max="berkutMaxEndDate || ''"
                            placeholder="Дата окончания"
                            name="treaty_term"
                            id="treaty.term"
                        />
                        <select-field
                            v-else
                            v-model="policy.treaty.term"
                            :options="{10:'10'}"
                            :required="true"
                            :disabled="this.$user.role !== 0"
                            :mb="5"
                            placeholder="Срок (дни)"
                            name="treaty_term"
                            id="treaty.term"
                        />
                      </div>
                    </div>
                    <div v-if="this.policy.product_type === 2" class="custom-select dynamic">
                      <label for="properties.duration">Срок</label>
                      <v-select
                          :loading="dictionaries.loading.durations"
                          v-model="duration"
                          input-id="properties.duration"
                          :options="availableDurations"
                          :disabled="dictionaries.loading.durations || dictionaries.disabled.duration"
                          :reduce="item => item.id"
                          placeholder="Выберите..."
                          class="mb-3 bg-gray-100 form rounded"
                          label="title"
                      />
                    </div>
                    <div class="custom-select dynamic">
                      <label for="properties.policy.manager" class="required">Менеджер</label>
                      <v-select
                          :loading="dictionaries.loading.managers"
                          v-model="policy.manager"
                          input-id="properties.policy.manager"
                          :options="dictionaries.managers"
                          :disabled="dictionaries.loading.managers || dictionaries.disabled.manager || policy.hasPaid"
                          :reduce="item => item.id"
                          :required="true"
                          placeholder="Выберите..."
                          class="mb-3 bg-gray-100 form rounded"
                          label="name"
                      />
                    </div>
                    <input-field
                        v-if="this.$user.apc"
                        v-model="policy.apc"
                        id="policy.apc"
                        name='policy.apc'
                        :disabled="true"
                        :mb="5"
                        placeholder="APC"
                        type="text"
                    />
                    <div v-else class="custom-select dynamic">
                      <label for="properties.policy.agent">Агент</label>
                      <v-select
                          :loading="dictionaries.loading.agents"
                          v-model="policy.agent"
                          input-id="properties.policy.agent"
                          :options="dictionaries.agents"
                          :disabled="dictionaries.loading.agents || dictionaries.disabled.agent || policy.hasPaid"
                          :reduce="item => item.id"
                          placeholder="Выберите..."
                          class="mb-3 bg-gray-100 form rounded"
                          label="name"
                      />
                    </div>
                    <template v-if="envState === 'dev' && otpEnabled && policy.hasPaid && !policy.hasOtpVerify">
                      <input-mask-field
                          v-if="policy.insurer.filter.resident && policy.insurer.filter.person"
                          v-model="otpTestPhone"
                          id="otpTestPhone"
                          name="otpTestPhone"
                          :mb="5"
                          placeholder="Номер телефона для OTP"
                          mask="7##########"
                          type="text"
                      />
                      <input-field
                          v-else
                          v-model="otpTestEmail"
                          id="otpTestEmail"
                          name="otpTestEmail"
                          :mb="5"
                          placeholder="Email для OTP"
                          type="text"
                      />
                    </template>
                    <input-mask-field
                        v-if="policy.hasOtpSend && !policy.hasOtpVerify && otpEnabled"
                        v-model="otpCode"
                        id="otpCode"
                        name="otpCode"
                        :required="true"
                        :mb="5"
                        placeholder="Код подтверждения"
                        mask="####"
                        type="text"
                    />
                    <input-mask-field
                        v-if="policy.hasPaid && policy.insurer.filter.person && (policy.hasOtpVerify || !otpEnabled)"
                        v-model="policy.paymentPhone"
                        :disabled="!!(acquiringResult.id)"
                        id="policy.paymentPhone"
                        name="policy.paymentPhone"
                        :required="true"
                        :mb="5"
                        placeholder="Номер телефона для оплаты"
                        mask="+7(###) ###-####"
                        type="text"
                    />
                    <template v-if="hasGlobalVerify">
                      <button v-if="!policy.hasPaid && policy.hasSave" @click="saveDraft" type="button" class="btn btn-sm btn-block btn-light-warning mt-1 mb-3">
                        <i v-if="saved" class="fa-solid fa-spinner fa-spin" style="width: 13px;height: 13px;"></i>
                        &nbsp; Сохранить как черновик
                      </button>
                      <div v-if="policy.hasCalc && !policy.residentRulesError">
                        <button v-if="!policy.hasPaid"
                                class="btn btn-sm btn-block btn-primary mt-1"
                                @click="calculate"
                                :disabled="!validateDriversLicense || !policy.manager"
                                type="button">
                          Рассчитать
                        </button>
                      </div>
                      <div>
                        <button v-if="policy.hasVerify && !policy.hasCalc && !policy.residentRulesError"
                                class="btn btn-sm btn-block btn-primary mt-1"
                                @click="verifyDocuments"
                                :disabled="changeDisabled"
                                type="button">
                          Проверить
                        </button>
                      </div>
                      <template v-if="otpEnabled">
                        <div v-if="policy.hasPaid && !policy.hasOtpVerify && otpCode.length !== 4">
                          <button
                              @click="sendOtpCode"
                              :disabled="otpCountdown !== 0 || changeDisabled"
                              type="button"
                              class="btn btn-sm btn-block btn-primary mt-1">
                            <span v-if="this.policy.hasOtpSend" class="indicator-label">Повторно отправить код <span v-if="this.otpCountdown > 0"> через {{ this.otpCountdown }} сек.</span></span>
                            <span v-else>Отправить код</span>
                          </button>
                        </div>
                        <div>
                          <button
                              v-if="policy.hasPaid && policy.hasOtpSend && !policy.hasOtpVerify && otpCode.length === 4"
                              :disabled="changeDisabled"
                              @click="verifyOtpCode"
                              type="button"
                              class="btn btn-sm btn-block btn-warning mt-1">
                            Подтвердить код
                          </button>
                        </div>
                      </template>
                    </template>
                    <template v-if="!acquiringResult.id">
                      <template v-if="policy.hasOtpVerify || !otpEnabled">
                        <div v-if="policy.hasPaid && !policy.insurer.filter.person">
                          <button @click="checkout(0)"
                                  class="btn btn-block btn-sm btn-primary cursor-pointer"
                                  v-html="'Перечисление'"
                                  :disabled="!validateImages || !validateDriversLicense"
                          ></button>
                        </div>
                        <div v-if="policy.hasPaid && policy.insurer.filter.person">
                          <button v-if="this.$route.query.isRewrite === '1' && policy.hasOwnProperty('add_payment') && policy.add_payment === 0"
                                  class="btn btn-block btn-sm btn-danger cursor-pointer"
                                  :disabled="!validateImages || !validateDriversLicense"
                                  @click="checkout(0)">
                            Переоформить
                          </button>
                          <div v-else-if="validateImages && validateDriversLicense">
                            <div class="row">
                              <div class="col-6">
                                <div @click="checkout(1, true)" class="btn btn-block btn-sm cursor-pointer btn-primary">
                                  Epay
                                </div>
                              </div>
                              <div class="col-6">
                                <div @click="checkout(1, false)" class="btn btn-block btn-sm cursor-pointer btn-danger">
                                  <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7475 17.1513C19.6113 17.5934 19.9984 19.2879 20.2299 20.865L20.2685 21.1339L20.2948 21.3169L20.4342 22.245C20.707 24.0171 21.2762 27.6955 21.2762 29.615C21.2762 30.0947 21.234 30.4629 21.1569 30.6652C21.0284 30.977 20.654 31.2762 20.137 31.5256C18.8861 31.8335 17.5786 32 16.2318 32C16.0892 32 15.9489 31.9931 15.8081 31.9889C15.2638 31.8343 14.8547 31.5762 14.6381 31.2235C13.9841 30.1589 13.9447 27.787 13.9316 25.0152L13.9301 24.6937L13.9248 23.8629C13.9035 20.9286 13.8852 18.3986 14.9513 17.4907C15.3642 17.1415 15.9509 17.0259 16.7475 17.1513ZM10.5037 23.5398C11.1243 23.5049 11.5234 26.5574 11.6036 28.8721C11.6598 30.4836 11.4906 31.1465 11.2204 31.3845C10.9145 31.2824 10.6139 31.1719 10.3177 31.0519C10.1201 30.6928 9.96907 30.128 9.87312 29.3882C9.58018 27.0633 9.83465 23.5808 10.5037 23.5398ZM26.0622 28.1014C26.0235 28.3134 25.9689 28.4772 25.9016 28.6154C25.371 29.0412 24.8133 29.4321 24.2297 29.7838C24.0438 29.8151 23.8787 29.7933 23.798 29.6569C23.0245 28.2978 22.7342 24.0342 23.4827 23.6631C24.4586 23.1917 26.2069 27.3643 26.0622 28.1014ZM16.0008 0C24.7145 0 31.8006 6.90062 31.996 15.4873L32 15.7841V15.9213C31.984 19.8 30.5566 23.3486 28.205 26.0952C28.1197 26.0524 27.9641 25.9123 27.6822 25.4906C27.3905 25.0667 24.8749 21.1953 24.8749 16.7581C24.8749 15.8873 26.1301 14.527 27.2408 13.333C28.0711 12.4345 28.8576 11.587 29.1472 10.9209C29.5161 10.0614 29.258 9.46125 28.8498 9.25782C28.4803 9.07703 27.9256 9.2089 27.5363 9.9003C26.8975 11.0193 26.6928 11.2284 25.761 11.9771C24.8441 12.7254 23.3864 13.4787 23.3864 12.5036C23.3864 11.9771 24.1983 10.7847 24.5994 9.9489C25.009 9.10377 24.5675 8.49196 23.7217 8.49196C22.0608 8.49196 20.9583 10.6077 20.9583 11.3407C20.9583 12.0731 21.3136 12.1774 21.3136 13.0303C21.3136 13.8896 19.4913 15.0042 17.7747 15.0042C16.122 15.0042 15.1636 14.6697 14.7665 13.7273L14.7158 13.595L14.601 13.2554C14.1938 12.0653 13.9017 11.2022 13.3932 10.3002C13.1232 9.8232 12.7066 9.49252 12.3463 9.20156C11.8754 8.83579 11.6311 8.49901 11.5801 8.24784C11.5331 7.99865 11.5078 7.52904 12.3128 6.4465C13.1161 5.37014 13.2287 4.557 12.8267 4.13743C12.681 3.98817 12.4326 3.89254 12.1136 3.89254C11.5494 3.89254 10.7654 4.19149 9.95745 5.01265C8.7015 6.2996 9.41451 7.52149 9.41451 8.05788C9.41451 8.59392 9.18442 8.89713 8.43071 9.6264C7.67148 10.3589 7.40945 10.9869 7.32262 13.5109C7.28935 14.8114 7.06031 15.56 6.85471 16.2238C6.67705 16.8056 6.51366 17.3526 6.50483 18.1429C6.49076 19.0187 6.63654 19.5831 6.80666 20.2343C6.97369 20.8362 7.15109 21.5259 7.26475 22.6796C7.44553 24.4655 7.38268 25.9741 7.054 27.516L6.96628 27.9023L6.94578 28.0133C6.87847 28.2843 6.79846 28.6134 6.69031 28.7367C2.64076 25.8604 0 21.163 0 15.8531C0 7.09843 7.1635 0 16.0008 0Z" fill="#FFF"/>
                                  </svg>
                                  Kaspi
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                    <div v-else>
                      <button class="btn btn-block btn-sm cursor-pointer"
                              :class="!policy.isEpay ? 'btn-danger' : 'btn-primary'"
                              @click="checkPayment()"
                              :disabled="this.acquiringResult.loaded"
                              v-html="this.acquiringResult.loaded ? 'Идет проверка' : 'Проверить оплату'">
                      </button>
                      <router-link v-if="policy.isEpay" :to="{name: 'EpayPayment', params: {id: policyId}}" class="btn btn-sm btn-block btn-light-primary mt-3" target="_blank">Открыть страницу оплаты</router-link>
                      <div v-if="acquiringResult.waiting" class="text-danger pt-3 text-center" v-html="acquiringResult.waiting"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </section>
      <section v-if="ticket">
        <div v-if="!ticket.hasOwnProperty('result')" class="rounded border p-6 bg-white info-panel mb-3 w-300px m-auto">
          <div class="mb-5 text-center">
            <i class="ki-outline ki-check-circle text-primary fs-7qx"></i>
          </div>
          <div class="first-info">
            <div class="fw-bold fs-6 text-primary mb-2 text-center">Полис успешно создан</div>
            <div class="text-gray-500" v-if="ticket.number">
              Номер: <span class="float-end text-gray-700 fw-bold" v-html="ticket.number"></span>
            </div>
            <div class="text-gray-500">
              Глобальный: <span class="float-end text-gray-700 fw-bold" v-html="ticket.global"></span>
            </div>
            <div class="text-gray-500">
              Дата начала: <span class="float-end text-gray-700 fw-bold" v-html="ticket.from"></span>
            </div>
            <div class="text-gray-500">
              Дата конца: <span class="float-end text-gray-700 fw-bold" v-html="ticket.to"></span>
            </div>
          </div>
          <a v-if="ticket.ticket" :href="ticket.ticket" target="_blank" class="btn btn-sm btn-primary btn-block mt-5 mb-2">Посмотреть чек</a>
          <span @click="this.$router.go(0)" class="btn btn-sm btn-light btn-block mt-5 mb-2 cursor-pointer">OK</span>
        </div>
        <div v-if="ticket.hasOwnProperty('result')" class="rounded border p-6 bg-white info-panel mb-3 w-300px m-auto">
          <div class="mb-5 text-center">
            <i class="ki-outline ki-check-circle text-primary fs-7qx"></i>
          </div>
          <div class="first-info">
            <div class="fw-bold fs-6 text-primary mb-2 text-center">Полис отправлен на обработку</div>
          </div>
          <span @click="this.$router.go(0)" class="btn btn-sm btn-light btn-block mt-5 mb-2 cursor-pointer">OK</span>
        </div>
      </section>
      <chief-modal
          :is-leader="changedChief.isLeader"
          :hash="changedChief.hash"
          :chief-added-list="chiefAddedListForModal"
          @addChief="addChief"
      />
      <vehicle-modal
          :car-added-list="policy.carAddedList"
          :vehicle="changedVehicle"
          :product-type="policy.product_type"
          :module="OsgpoModule"
          @addVehicle="addVehicle"
      />
      <podft-upload-modal
          :number="modalData.number"
          :index="modalData.index"
          :text="modalData.text"
          :type="modalData.type"
          :ulid="policy.number"
          @updatePodftData="updatePodftData"
      />
      <customer-modal
          v-if="policy.product_type"
          :client-added-list="policy.clientAddedList"
          :client="changedClient"
          :product-type="policy.product_type"
          :has-paid="policy.hasPaid"
          :ulid="policy.number"
          :module="OsgpoModule"
          @addClient="addClient"
      />
      <drivers-license-modal
          :document-number="changedDriversLicense.documentNumber"
          :hash="changedDriversLicense.hash"
          :iin="changedDriversLicense.iin"
          :resident="changedDriversLicense.resident"
          @add-drivers-license="addDriversLicense"
      />
      <alert-modal title="У вас не настроен терминал!"
                   description="Пожалуйста, обратитесь к ответственному бухгалтеру. <br/>Если терминал настроен, необходимо обновить токен или вновь авторизоваться.<br/><br/>Без терминала нельзя заключить полис!"
                   :timer="3"/>
    </template>
    <template v-else>
      <div class="bg-white info-panel mb-3 w-300px m-auto p-10 rounded">
        <div class="p-3 mb-3">
          <b><span class="text-gray-800">У страхователя</span> "{{insurerBmgError.iin}}"</b><br>
          <small class="text-danger">{{insurerBmgError.error}}</small>
        </div>
        <input-mask-field
            v-model="insurerBmgError.phone"
            id="insurerBmgError.phone"
            name="insurerBmgError.phone"
            :disabled="this.loaded"
            :required="true"
            :mb="5"
            placeholder="Номер телефона"
            mask="+7(###) ###-####"
            type="text"
        />
        <button @click="getPolicyByGlobal" :disabled="insurerBmgError.phone.length < 16" class="btn btn-block btn-primary btn-sm">
          Подтвердить
        </button>
      </div>
    </template>
    <policy-history-popup :product="this.policy.product"/>
  </section>
  <template v-else>
    <loader-full :text="loaderText"/>
  </template>
</template>

<script>
import axios from 'axios'
// Fields
import InputMaskField       from '@/components/Fields/InputMaskField'
import CheckboxField        from '@/components/Fields/CheckboxField'
import SelectField          from '@/components/Fields/SelectField'
import InputField           from '@/components/Fields/InputField'
import DateField            from '@/components/Fields/DateField'
import vSelect              from 'vue-select'
// Modal
import PodftUploadModal    from '@/components/Podft/PodftUploadModal'
import CustomerModal       from '@/components/Form/Customer/CustomerModal'
import VehicleModal        from '@/components/Form/Uidb/Modals/VehicleModal'
import ChiefModal          from '@/components/Form/Uidb/Modals/ChiefModal'
import DriversLicenseModal from '@/components/Modals/DriversLicenseModal'
// Card
import CustomerCard       from '@/components/Form/Customer/CustomerCard'
import VehicleCard        from '@/components/Form/Uidb/Card/VehicleCard'
// Other
import DocumentUploadsFree from '@/components/Form/Uidb/Document/DocumentUploadsFree'
import DocumentUploads     from '@/components/Form/Uidb/Document/DocumentUploads'
import PageNotFound        from '@/views/PageNotFound'
import LoaderFull          from '@/components/Main/LoaderFull'
import AlertMain           from "@/components/Main/AlertMain.vue";
import AlertModal          from "@/components/Main/AlertModal.vue";
// Helpers
import OsgpoModule         from '@/helpers/Modules/Product/OsgpoModule'
import BpmOsgpoModule      from '@/helpers/Modules/Product/BpmOsgpoModule'
import { ulid }            from 'ulidx'
import permissions         from '@/helpers/permissions'
import policies from "@/views/Policies.vue";
import {uid} from "chart.js/helpers";
import PolicyHistoryPopup from "@/components/Policy/PolicyHistoryPopup.vue";

export default {
  name: 'Ogpo',
  components: {
    PolicyHistoryPopup,
    AlertModal, AlertMain, InputField, PodftUploadModal, DocumentUploads, InputMaskField, CheckboxField, VehicleModal, DriversLicenseModal,
    SelectField, VehicleCard, ChiefModal, LoaderFull, DateField, vSelect, CustomerModal, CustomerCard, DocumentUploadsFree,
  },
  props: {
    draftData: Object
  },
  emits: ['addClient'],
  data () {
    return {
      OsgpoModule,
      BpmOsgpoModule,
      policy: {
        product_type: null,
        ip:           null,
        apc:          null,
        paymentPhone: null,
        manager:      null,
        agent:        null,
        insureds:     [],
        insurer:      null,
        beneficiary:  null,
        leader:       null,
        product:      'OGPO_WEB_EA',
        vehicle:      [],
        number:       null,
        treaty: {
          date: '',
          term: 12
        },
        calculationDate: null,
        insuredsShow:    true,
        vehicleShow:     true,
        isDrive:         false,
        premium:         null,
        hasPaid:         false,
        hasVerify:       false,
        hasCalc:         false,
        hasSave:         false,
        hasOtpVerify:    false,
        hasOtpSend:      false,
        clientAddedList: [],
        chiefAddedList:  [],
        carAddedList:    [],
        residentRules: {
          insurer: null,
          insured: [],
          vehicle: [],
        },
        residentRulesError: null,
        podftSuccess: true,
      },
      otpCode:        '',
      otpTimeout:     null,
      otpCountdown:   0,
      // otpEnabled:     true,
      // envState:       'prod',
      otpEnabled:     process.env.VUE_APP_STATE !== 'loc',
      envState:       process.env.VUE_APP_STATE,
      otpTestPhone:   null,
      otpTestEmail:   null,
      isEpay:         false,
      validateImages: false,
      validateDriversLicense: false,
      saved:          false,
      loaded:         false,
      loaderText:     '',
      duration:       null,
      berkutMaxEndDate: null,
      changedClient: {
        new:       true,
        key:       null,
        data:      null,
        isInsurer: null
      },
      changedChief: {
        isLeader:   false,
        hash:       null
      },
      changedDriversLicense: {
        documentNumber:    null,
        hash:   null,
        iin:    null,
        resident: false
      },
      changedVehicle: null,
      errorClientKey: [],
      changeDisabled: false,
      isInsurer:      false,
      modalData: {
        number: '',
        index: '',
        text: '',
        type: ''
      },
      ticket:   null,
      acquiringResult: {
        id:      null,
        loaded:  false,
        waiting: null
      },
      iin:             null,
      hasGlobalVerify: true,
      insurerBmgError: {
        error: null,
        phone: '7',
        iin:   null
      },
      dictionaries: {
        managers: [],
        agents:   [],
        durations: [
          {id: {type: 'day', value: 5}, title: '5 дней'},
          {id: {type: 'day', value: 10}, title: '10 дней'},
          {id: {type: 'day', value: 15}, title: '15 дней'},
          {id: {type: 'month', value: 1}, title: '1 месяц'},
          {id: {type: 'month', value: 2}, title: '2 месяца'},
          {id: {type: 'month', value: 3}, title: '3 месяца'},
          {id: {type: 'month', value: 4}, title: '4 месяца'},
          {id: {type: 'month', value: 5}, title: '5 месяцев'},
          {id: {type: 'month', value: 6}, title: '6 месяцев'},
          {id: {type: 'month', value: 7}, title: '7 месяцев'},
          {id: {type: 'month', value: 8}, title: '8 месяцев'},
          {id: {type: 'month', value: 9}, title: '9 месяцев'},
          {id: {type: 'month', value: 10}, title: '10 месяцев'},
          {id: {type: 'month', value: 11}, title: '11 месяцев'},
          {id: {type: 'month', value: 12}, title: '12 месяцев'},
        ],
        loading: {
          managers: false,
          agents:   false,
        },
        disabled: {
          manager: false,
          agent:   false,
        }
      },
      policyId: null,
    }
  },
  created() {
    if (this.$user.role === 8 && !this.$user.apc) this.$router.push({path: 'not-found', component: PageNotFound})
    this.policy.apc = this.$user.apc ?? null
  },
  mounted() {
    if (this.$route.query.draft) {
      this.loaded = true
      axios.get('/api/draft/item/'+this.$route.query.draft+'/OGPO_WEB_EA')
          .then(res => {
            if ('result' in res.data && !res.data.result) {
              this.$notifyError(res.data)
              this.$router.replace({ query: {} })
            } else {
              if (res.data.policy && res.data.policy.product === 'OGPO_WEB_EA') {
                if (res.data.policy.isDrive) {
                  res.data.policy.insureds.splice(0, 1)
                  const index = res.data.policy.clientAddedList.indexOf(res.data.policy.insurer.client.iin ?? res.data.policy.insurer.document?.number);
                  res.data.policy.clientAddedList.splice(index, 1);
                }
                this.policy = res.data.policy
                this.syncCarAddedList()
                if (!this.policy.number && this.$route.query.draft) this.policy.number = parseInt(this.$route.query.draft)
                if (/^\d+$/.test(this.$route.query.draft)) this.policy.number = ulid()
              } else {
                this.$notifyError({message:'Черновик не найден'})
              }
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.policy.treaty.date = this.today
            this.policy.hasCalc     = false
            this.loaded             = false
            this.getManagers()
          })
    } else {
        this.getManagers()
    }
    if (this.$route.query.global) {
      if (this.$route.query.hasOwnProperty('global') && this.$route.query.hasOwnProperty('isRewrite')) {
        this.getPolicyByGlobal()
      } else {
        this.$router.push({path: 'not-found', component: PageNotFound})
      }
    }
  },
  computed: {
    today() {
      let yourDate = new Date(Date.now() + ( 3600 * 1000 * 24))
      return yourDate.toISOString().split('T')[0]
    },
    chiefAddedListForModal() {
      const findDuplicates = (arr) => {
        const seen = new Set();
        const duplicates = new Set();

        arr.forEach((item) => {
          if (seen.has(item)) {
            duplicates.add(item);
          } else {
            seen.add(item);
          }
        });

        return [...duplicates];
      };

      const {chiefAddedList = [], insurer} = this.policy;
      const duplicates = findDuplicates(chiefAddedList);

      const filterCondition = this.changedChief.isLeader
          ? (item) => {
            if (!insurer.beneficiaries || !Array.isArray(insurer.beneficiaries)) {
              return true;
            }
            return !insurer.beneficiaries.some((leader) => leader.doc === item);
          }
          : (item) => {
            if (!insurer.leader || !insurer.leader.doc) {
              return true;
            }
            return item !== insurer.leader.doc;
          };
      return [
        ...chiefAddedList.filter(filterCondition),
        ...duplicates,
      ];
    },
    getUser() {
      return this.$store.state.user
    },
    vehicleIdentity() {
      return (this.policy.vehicle || []).map(item => `${item?.vin || ''}|${item?.registration?.number || ''}`).join(';')
    },
    availableDurations() {
      const list = this.dictionaries.durations || []
      if (this.policy.product_type !== 2 || !this.berkutMaxEndDate || !this.policy.treaty.date) {
        return list
      }
      return list.filter(item => this.calculateEndDate(this.policy.treaty.date, item.id) <= this.berkutMaxEndDate)
    },
  },
  methods: {
    addClient(val) {
      switch (val.clientType) {
        case 1:
          this.addInsurer(val.data)
          break
        case 2:
          this.addInsured(val.data, val.key)
          break
      }
    },
    addInsurer(data) {
      this.policy.insurer = data;
      if (this.policy.isDrive && (data.client.iin ? data.client.iin === this.policy.insurer.client.iin : data.document?.number === this.policy.insurer.document?.number)) {
        this.policy.insurer = data
      }
    },
    addInsured(data, key = null) {
      const insurerTemp = [this.policy.insurer.client.iin, this.policy.insurer.client.title, this.policy.insurer.document?.issued, this.policy.insurer.document?.number]
      const insuredTemp = [data.client.iin, data.client.title, data.document?.issued, data.document?.number]
      if (JSON.stringify(insurerTemp) === JSON.stringify(insuredTemp)) {
        this.policy.isDrive = true;
        this.policy.insurer.driver = data.driver;
        this.policy.insurer.client.politician = data.client.politician
      } else if (key === null) {
        this.policy.insureds.push(data);
        if (!(data.entrepreneur && data.entrepreneur.name)) {
          this.policy.clientAddedList.push(data.client.iin ?? data.document?.number);
        }
      } else {
        this.policy.insureds[key] = data;
      }
    },
    setClient(clientType, data = null, key = null) {
      this.policy.hasCalc = false
      this.policy.hasPaid = false
      this.changedClient  = {clientType: clientType, data: data, key: key}
      setTimeout(() => {new bootstrap.Modal('#customerModal', {}).show()}, 10)
    },
    deleteClient(key) {
      if (!this.policy.insureds[key].client.iin && this.policy.insureds[key].document?.number === null) {
        this.deleteClientDocuments(this.policy.insureds[key]).then(() => {
          this.policy.insureds.splice(key, 1)
          if (this.$route.query.draft) {
            this.saveDraft();
          }
        })
        return
      }
      if ((this.policy.insureds[key].client.iin ? this.policy.insureds[key].client.iin === this.policy.insurer.client.iin : this.policy.insureds[key].document?.number === this.policy.insurer.document?.number) &&
          !((this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name) || (this.policy.insureds[key].entrepreneur && this.policy.insureds[key].entrepreneur.name))) {
        this.policy.isDrive = false
      } else {
        this.deleteClientDocuments(this.policy.insureds[key]).then(() => {
          this.policy.clientAddedList.splice(key, 1)
          if (this.policy.insureds[key].client.isInsurer) {
            this.policy.insureds.splice(key, 1)
            if (this.policy.insureds.length !== 0) {
              this.policy.insureds[0].client.isInsurer = true
            }
          } else {
            this.policy.insureds.splice(key, 1)
          }
          if (this.$route.query.draft) {
            this.saveDraft();
          }
        })
      }
    },
    updateImages(image, action) {
      if (image.kind === 1) {
        this.policy.insurer.images = this.modifyImages(this.policy.insurer.images, image, action);
      }

      this.policy.insureds.forEach((item, key) => {
        if (image.kind === 2 && key === image.itemKey) {
          item.images = this.modifyImages(item.images, image, action);
        }
      });

      this.policy.vehicle.forEach((item, key) => {
        if (image.kind === 3 && key === image.itemKey) {
          item.images = this.modifyImages(item.images, image, action);
        }
      });

      if (this.$route.query.draft) {
        this.saveDraft();
      }
    },
    modifyImages(images, image, action) {
      if (action === 'add') {
        return [...new Set([...(images ?? []), image])];
      } else if (action === 'delete') {
        return images.filter(img => img.id !== image.id);
      }
      return images;
    },
    addDocument(val) {
      this.updateImages(val, 'add');
    },
    deleteDocument(val) {
      this.updateImages(val, 'delete');
    },
    async deleteClientDocuments(client) {
      return await axios.post('/api/document/delete-client-images', client)
    },
    setChief(isLeader = false) {
      this.changedChief = {isLeader: isLeader, hash: Math.floor(Math.random() * 10) + 1}
      new bootstrap.Modal('#ChiefModal', {}).show()
    },
    addChief(val) {
      if (this.changedChief.isLeader) {
        this.policy.insurer.leader = val.user
      } else {
        this.policy.insurer.beneficiaries.push(val.user)
      }
      if (!this.policy.hasOwnProperty('chiefAddedList')) this.policy.chiefAddedList = []
      this.policy.chiefAddedList.push(val.user.doc)
      const myModalEl = document.getElementById('ChiefModal')
      const modal = bootstrap.Modal.getInstance(myModalEl)
      modal.hide()
    },
    deleteChief(key, isLeader = false) {
      const docNum = isLeader ? this.policy.insurer.leader.doc : this.policy.insurer.beneficiaries[key].doc
      const docKey = this.policy.chiefAddedList.indexOf(docNum)
      if (isLeader) {
        this.policy.insurer.leader = null
      } else {
        this.policy.insurer.beneficiaries.splice(key, 1)
      }
      this.policy.chiefAddedList.splice(docKey, 1);
    },
    syncCarAddedList() {
      this.policy.carAddedList = this.policy.vehicle.flatMap(v =>
          [v.number, v.vin].filter(item => item != null && item !== '')
      )
    },
    addVehicle(val) {
      if (val.data) {
        this.policy.vehicle[val.key] = val.data
      } else {
        let clone = structuredClone(val);
        clone['beingVerify'] = false
        this.policy.vehicle.push(clone)
      }
      this.syncCarAddedList()
    },
    setChangedVehicle(key, isNew = false) {
      this.changedVehicle = {
        new: isNew,
        key:key,
        data:structuredClone(this.policy.vehicle[key]),
        hash: Math.floor(Math.random() * 10) + 1
      }
      new bootstrap.Modal('#vehicleModal', {}).show()
    },
    deleteVehicle(key) {
      this.policy.vehicle.splice(key, 1)
      this.syncCarAddedList()
    },
    setDriversLicense(documentNumber, iin, resident) {
      this.changedDriversLicense = {documentNumber: documentNumber, hash: Math.floor(Math.random() * 10) + 1, iin: iin, resident: resident}
      new bootstrap.Modal('#DriversLicenseModal', {}).show()
    },
    addDriversLicense(val, documentNumber) {
      if (this.policy.insurer.document?.number === documentNumber) {
        this.policy.insurer.driver.document = val
      }
      if (this.policy.insureds.some(item => item.document?.number === documentNumber)) {
        this.policy.insureds.find(item => item.document?.number === documentNumber).driver.document = val
      }
      const myModalEl = document.getElementById('DriversLicenseModal')
      const modal = bootstrap.Modal.getInstance(myModalEl)
      modal.hide()
    },
    deleteDriversLicense(documentNumber) {
      if (this.policy.insurer.document?.number === documentNumber) {
        this.policy.insurer.driver.document = null
      }
      if (this.policy.insureds.some(item => item.document?.number === documentNumber)) {
        this.policy.insureds.find(item => item.document?.number === documentNumber).driver.document = {
          number: null,
          issued: null
        }
      }
    },
    sendOtpCode() {
      this.changeDisabled = true
      let client = structuredClone(this.policy.insurer);
      if (this.envState === 'dev') {
        client.client.phone = this.otpTestPhone
        client.client.email = this.otpTestEmail
      }
      axios.post('/api/otp/send',{
        phone: client.client.phone,
        email: client.client.email,
        resident: client.filter.resident,
        person: client.filter.person,
        ulid: this.policy.number
      })
          .then(res => {
            if (res.data.result) {
              this.$notifySuccess({message: res.data.code ? `Код отправлен: ${res.data.code}` : (res.data.type === 'sms' ? 'СМС отправлена' : 'Письмо отправлено')})
              this.policy.hasOtpSend = true;
              this.startOtpTimer()
            } else {
              this.$notifyError(res.data)
            }
          }).finally(() => {
            this.changeDisabled = false
          })
    },
    verifyOtpCode() {
      let client = structuredClone(this.policy.insurer);
      if (this.envState === 'dev') {
        client.client.phone = this.otpTestPhone
        client.client.email = this.otpTestEmail
      }
      axios.post('/api/otp/verify', {
        ulid: this.policy.number,
        phone: client.client.phone,
        email: client.client.email,
        code: this.otpCode})
          .then(res => {
            if (res.data.result) {
              this.$notifySuccess({message: 'Код подтвержден'})
              this.policy.hasOtpVerify = true
              this.otpCode = ''
            } else {
              this.$notifyError(res.data)
              this.otpCode = ''
            }
      })
    },
    startOtpTimer() {
      this.otpCountdown = 60
      this.timer = setInterval(() => {
        this.otpCountdown -= 1
        if (this.otpCountdown === 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    calculate() {
      if (!this.policy.ip) this.getIp().then(res => {this.policy.ip = res.data.ip})
      this.loaderText = 'Идет калькуляция полиса'
      this.loaded = true
      const headers = { policy:this.policy }
      axios.post('/api/calculate/ogpo', headers)
          .then(res => {
            if (res.data.errors) {
              this.$notifyError(res.data)
            } else {
              if (res.data.premium) {
                this.policy.premium         = res.data.premium
                this.policy.calculationDate = res.data.calculationDate
                this.policy.hasPaid         = true
                if (res.data.hasOwnProperty('classes')) {
                  this.policy.insurer.class = res.data.classes.insurer
                  if (res.data.classes.insureds.length > 0) {
                    res.data.classes.insureds.forEach((value, key) => {
                      this.policy.insureds[key].class = value
                    })
                  }
                  this.policy['setClasses'] = true
                  setTimeout(() => {
                    this.policy.hasCalc   = true
                    this.policy.hasSave   = true
                    this.policy.hasVerify = true
                    this.policy.hasPaid   = true
                    this.policy.premium         = res.data.premium
                    this.policy.calculationDate = res.data.calculationDate
                    this.policy.hasPaid         = true
                    this.policy.setClasses      = false
                    this.loaded                 = false
                  }, 700)
                }
                if (res.data.hasOwnProperty('add_payment')) this.policy['add_payment'] = res.data.add_payment
                if (res.data.hasOwnProperty('refund'))      this.policy['refund']      = res.data.refund
              } else {
                this.$notifyError(res.data)
              }
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loaderText = ''
            if ('setClasses' in this.policy) {
              this.loaded = !this.policy.setClasses
            } else {
              this.loaded = false
            }
          })
    },
    saveDraft() {
      this.saved = true
      const headers = { policy: this.policy }
      axios.post('/api/draft/save', headers)
          .then(res => {
            this.policy.number = res.data
            this.$notifySuccess({message: res.data, title: 'Сохранено'})
            this.$router.replace({name: 'Ogpo', query: {product: this.policy.product_type, draft: res.data}})
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.saved = false
          })
    },

    setProduct(type) {
      if (BpmOsgpoModule.Validator.isUserAllowed(this.$user) && type === 1) {
        this.$router.replace({name: 'BpmOgpo'})
      } else {
        this.$router.replace({name: 'Ogpo', query: {product: type}})
        this.policy.product_type = type
        if (type === 1) this.policy.treaty.term = 12
        if (type === 2) this.policy.treaty.term = new Date(Date.now() + ( 3600 * 1000 * 24 * 5)).toISOString().split('T')[0]
        if (type === 3) this.policy.treaty.term = 10
      }
    },
    getProductNameByType(type){
      const data = {
        1: 'ОГПО ВТС',
        2: 'Временный въезд',
        // 3: 'Транзит',
      }
      if (this.$route.path === '/ogpo') {
        document.getElementById("pageName").innerHTML = type ? data[type] : 'ОГПО ВТС'
        document.getElementById("pageNameMain").innerHTML = type ? data[type] : 'ОГПО ВТС'
        document.title = type ? data[type] : 'ОГПО ВТС'
      }
      return type ? data[type] : 'ОГПО ВТС'
    },
    uploadData(number, text, type, index) {
      this.modalData.number = number
      this.modalData.index  = index
      this.modalData.text   = text
      this.modalData.type   = type
      new bootstrap.Modal('#podftUploadModal', {}).show()
    },
    updatePodftData(val) {
      if (val.type === 0) {
        this.policy.insurer.podft = val.data
      } else if (val.type === 1) {
        this.policy.insureds[val.index].podft = val.data
      } else if (val.type === 2) {
        this.policy.vehicle[val.index].podft = val.data
      }
      this.saveDraft()
    },
    getPolicyByGlobal() {
      this.loaded = true
      let headers = {global: this.$route.query.global, isGlobal: this.$route.query.isGlobal, isRewrite:this.$route.query.isRewrite};
      if (this.insurerBmgError.phone.length > 3) headers['phone'] = this.insurerBmgError.phone
      axios.post('/api/contracts/ogpo/policy-get', headers)
          .then(res => {
            if (res.data.hasOwnProperty('result')) {
              if (res.data.hasOwnProperty('iin')) {
                this.insurerBmgError.iin = res.data.iin
                this.insurerBmgError.error = res.data.error
              } else {
                this.$router.push({path: 'not-found', component: PageNotFound})
              }
            } else {
              this.insurerBmgError = {iin: null, error: null, phone: '7'}
              this.policy = res.data
              this.syncCarAddedList()
              this.policy.number = ulid()
              this.getIp()
                  .then(res => {this.policy.ip = res.data.ip})
                  .catch(() => {confirm(`Ошибка загрузки продукта`) ? location.reload() : location.reload()})
                  .finally(() => {
                    this.policy['dictionaries'] = {
                      managers: [],
                      agents:   [],
                      loading: {
                        managers: false,
                        agents:   false,
                      },
                      disabled: {
                        manager: false,
                        agent:   false,
                      }
                    }
                    this.getManagers()
                  });
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.loaded = false
          })
    },
    // Verify
    async verifyDocuments() {
      if (this.getUser && !this.getUser.hasTerminal && permissions.groupSale().includes(this.getUser.role) && this.getUser.role !== 0) {
        new bootstrap.Modal('#alertModal', {}).show()
      }
      this.changeDisabled = true
      this.policy.podftSuccess = true
      this.berkutMaxEndDate = null
      this.verifyClient(true, this.policy.insurer, this.policy.number)
          .then(res => {
            if (!res.data.hasOwnProperty('success')) {
              this.policy.podftSuccess = false
              this.policy.insurer.podft.message   = 'Время ожидания ответа от сервера истекло. Попробуйте снова.'
              this.policy.insurer.podft.error     = res.data
              this.policy.insurer.podft.setDocument = false
              this.policy.insurer.podft.success   = false
              if (res.data.hasOwnProperty('result') && !res.data.result) {
                this.$notifyError(res.data)
              }
            } else {
              this.policy.insurer.podft = res.data
              if (!res.data.success) this.policy.podftSuccess = res.data.success
              if (res.data.canEdit) this.policy.insurer.podft.canEdit = true
              else this.policy.insurer.podft.canEdit = false
            }
          })
          .catch(err => {
            console.log(err.message)
            this.policy.podftSuccess = false
            this.policy.insurer.podft.message = 'Обновите страницу (Ctrl + Shift + R) и попробуйте снова.'
            this.policy.insurer.podft.error = err.message
            this.policy.insurer.podft.setDocument = false
            this.policy.insurer.podft.success = false
          })
          .finally(async () => {
            this.policy.insurer.beingVerify = false
            for (const key in this.policy.insureds) {
              if (this.policy.insureds[key].client.title == 'ЛИЦА, НА ОСНОВАНИИ ПУТЕВЫХ ЛИСТОВ И/ИЛИ ДОВЕРЕННОСТИ ВЫДАННЫХ СТРАХОВАТЕЛЕМ') continue
              if ((this.policy.insureds[key].client.iin ?? this.policy.insureds[key].document?.number) !== (this.policy.insurer.client.iin ?? this.policy.insurer.document?.number)) {
                await this.verifyClient(false, this.policy.insureds[key], this.policy.number)
                    .then(res => {
                      if (!res.data.hasOwnProperty('success')) {
                        this.policy.podftSuccess = false
                        this.policy.insureds[key].message   = 'Время ожидания ответа от сервера истекло. Попробуйте снова.'
                        this.policy.insureds[key].error     = res.data
                        this.policy.insureds[key].setDocument = false
                        this.policy.insureds[key].success   = false
                        if (res.data.hasOwnProperty('result') && !res.data.result) {
                          this.$notifyError(res.data)
                        }
                      } else {
                        this.policy.insureds[key].podft = res.data
                        if (!res.data.success) this.policy.podftSuccess = res.data.success
                        if (res.data.canEdit) this.policy.insureds[key].podft.canEdit = true
                        else this.policy.insureds[key].podft.canEdit = false
                      }
                    })
                    .catch(err => {
                      console.log(err.message)
                      this.policy.podftSuccess = false
                      this.policy.insureds[key].message = 'Обновите страницу (Ctrl + Shift + R) и попробуйте снова.'
                      this.policy.insureds[key].error = err.message
                      this.policy.insureds[key].setDocument = false
                      this.policy.insureds[key].success = false
                    })
                    .finally(() => {this.policy.insureds[key].beingVerify = false})
              }
            }
            for (const key in this.policy.vehicle) {
              await this.verifyVehicle(this.policy.vehicle[key], this.policy.number)
                  .then(res => {
                    if (!res.data.hasOwnProperty('success')) {
                      this.policy.podftSuccess = false
                      this.policy.vehicle[key].podft.error    = res.data
                      this.policy.vehicle[key].podft.message  = 'Время ожидания ответа от сервера истекло. Попробуйте снова.'
                      this.policy.vehicle[key].podft.setDocument = false
                      this.policy.vehicle[key].podft.success  = false
                      if (res.data.hasOwnProperty('result') && !res.data.result) {
                        this.$notifyError(res.data)
                      }
                    } else {
                      this.policy.vehicle[key].podft = res.data
                      if (!res.data.success) {
                        this.policy.podftSuccess = res.data.success
                        if (res.data.message) this.$notifyError({message: res.data.message})
                      } else {
                        this.collectBerkutMaxEndDate(res.data)
                      }
                    }
                  })
                  .catch(err => {
                    console.log(err.message)
                    this.policy.podftSuccess = false
                    this.policy.vehicle[key].podft.message = 'Обновите страницу (Ctrl + Shift + R) и попробуйте снова.'
                    this.policy.vehicle[key].podft.error = err.message
                    this.policy.vehicle[key].podft.setDocument = false
                    this.policy.vehicle[key].podft.success = false
                  })
                  .finally(() => {this.policy.vehicle[key].beingVerify = false})
            }
            if (this.$user.role !== 0) {
              await this.verifyTerminal(this.$user.c_id)
                  .then(res => {
                    if (!res.data.result) {
                      this.policy.podftSuccess = false
                      this.$notifyError(res.data)
                    }
                  }).catch(err => {
                    console.log(err.message)
                  })
            }

            this.changeDisabled = false
            const termReset = this.applyBerkutTermLimit()
            this.policy.hasCalc = !termReset && this.policy.podftSuccess
            if (!this.policy.podftSuccess || termReset) this.saveDraft()
          })
    },
    async verifyClient(isInsured, data, ulid) {
      data.beingVerify = true
      let headers = {
        // unprofitable: this.policy.insurer.unprofitable.result,
        document_type:  data.document.type_id,
        product_type:   this.policy.product_type,
        patronymic:     data.client.patronymic,
        politician:     data.client.politician,
        isInsured:      isInsured,
        pensioner:      data.driver.pensioner,
        birthday:       data.client.birthday,
        resident:       data.filter.resident,
        person:         data.filter.person,
        isEntrepreneur: data.client?.entrepreneur ? 1 : 0,
        surname:        data.client.surname,
        product:        this.policy.product,
        rewrite:        false,
        title:          data.client.title,
        phone:          data.client.phone,
        name:           data.client.name,
        iin:            data.client.iin,
        ulid:           ulid,
      }
      if (!isInsured) {
        const insured = {
          experience: data.driver.experience ? 1 : 3,
          class_id:   data.class.class_id,
          age:        data.driver.age,
        }
        headers = Object.assign(headers, insured)
      }
      return await axios.post('/api/verify/client', headers)
    },
    async verifyVehicle(data, ulid) {
      data.beingVerify = true
      const headers = {
        product_type: this.policy.product_type,
        region_id:    data.registration.region_id,
        product:      this.policy.product,
        rewrite:      false,
        kato:         data.registration.kato,
        ulid:         ulid,
        vin:          data.vin,
        number:       data.registration.number,
        treaty_date:  this.policy.treaty.date,
      }
      return await axios.post('/api/verify/vehicle', headers)
    },
    async verifyTerminal(c_id) {
      return await axios.post('/api/verify/terminal', {c_id: c_id})
    },
    // Policy
    checkout(type, isEpay = false) {
      if (type === 1) this.policy.isEpay = isEpay
      this.loaded = true
      this.changeDisabled = true
      this.loaderText = 'Идет создание полиса'
      const headers = { payment: type, policy: this.policy, paymentPhone: this.policy.paymentPhone }
      if (this.$route.query.global) {
        const data = {global: this.$route.query.global, isRewrite: this.$route.query.isRewrite}
        Object.assign(headers, data);
      }
      axios.post('api/contracts/checkout', headers)
          .then(res => {
            if (res.data.global) {
              this.ticket = res.data
            } else if (res.data.result){
              if (res.data.hasOwnProperty('processing') && res.data.processing) {
                this.ticket = res.data
              } else {
                this.acquiringResult.id = isEpay ? res.data.policyId : res.data.result
                if (this.policy.isEpay) this.policyId = res.data.policyId
                this.$notifySuccess('Оплата успешно отправлено!')
              }
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError({message: 'Ошибка выставления счета, попробуйте ещё раз.'})
          })
          .finally(() => {
            this.loaderText = ''
            this.loaded = false
          })
    },
    checkPayment(payment = 1) {
      this.acquiringResult.loaded = true
      const headers = { id: this.acquiringResult.id, payment:payment }
      axios.post('api/contracts/check-payment', headers)
          .then(res => {
            if (res.data.ticket) this.ticket = res.data
            if (res.data.waiting) {
              this.acquiringResult.waiting = res.data.waiting
              setTimeout(() => {this.acquiringResult.waiting = null}, 3000)
            }
          })
          .catch((err) => {
            this.$notifyError({message: 'Ошибка проверки оплаты, попробуйте ещё раз.'})
          })
          .finally(() => {
            this.acquiringResult.loaded = false
          })
    },
    async getIp() {
      return await axios.get('api/get-ip')
    },
    verifyPolicy() {
      let result = true
      for (const key in this.policy.insureds) {
        if (!result) return false
        result = this.policy.insureds[key].hasOwnProperty('document')
      }
      if (result) {
        for (const key in this.policy.vehicle) {
          if (!result) return false
          result = this.policy.vehicle[key].hasOwnProperty('registration')
        }
      }
      return result
    },
    // Dictionaries
    getManagers() {
      this.dictionaries.loading.managers = true
      axios.get('/api/dictionaries/order/managers')
          .then(res => {
            if (res.data.result) this.dictionaries.managers = res.data.data
          })
          .catch(err => this.$notifyError({message: err?.response?.data?.message ?? err.message}))
          .finally(() => {
            this.dictionaries.loading.managers = false
            if (this.$user.role === 3) {
              this.policy.manager = this.$user.id
              this.dictionaries.disabled.manager = true
            }
            if (this.$user.role === 4 || this.$user.role === 8) {
              if (this.dictionaries.managers.length) {
                this.policy.manager = this.dictionaries.managers[0].id
                this.dictionaries.disabled.manager = true
              }
            }
          })
    },
    calculateEndDate(startDate, duration) {
      let date = new Date(startDate);
      if (duration.type === 'day') {
        date.setDate(date.getDate() + duration.value);
      } else if (duration.type === 'month') {
        date.setMonth(date.getMonth() + duration.value);
      }
      date.setDate(date.getDate() - 1);
      return date.toISOString().split('T')[0];
    },
    formatBerkutMaxEnd(isoDate) {
      const normalized = this.normalizePolicyDate(isoDate)
      if (!normalized) return ''
      const [year, month, day] = normalized.split('-')
      return `${day}.${month}.${year}`
    },
    normalizePolicyDate(value) {
      if (!value) return ''
      const text = String(value).trim()
      if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10)
      if (/^\d{2}\.\d{2}\.\d{4}/.test(text)) {
        const [day, month, year] = text.split('.')
        return `${year}-${month}-${day}`
      }
      return ''
    },
    isTermAfterBerkutMax(term, maxEnd) {
      const termDate = this.normalizePolicyDate(term)
      const maxDate = this.normalizePolicyDate(maxEnd)
      return !!(termDate && maxDate && termDate > maxDate)
    },
    berkutLimitedMessage(maxEndDate) {
      return `Срок страхования ограничен. Полис можно оформить только до ${this.formatBerkutMaxEnd(maxEndDate)}`
    },
    collectBerkutMaxEndDate(payload) {
      if (this.policy.product_type !== 2) return
      const maxEnd = this.normalizePolicyDate(payload?.max_end_date)
      if (!maxEnd) return
      if (!this.berkutMaxEndDate || maxEnd < this.berkutMaxEndDate) {
        this.berkutMaxEndDate = maxEnd
      }
    },
    applyBerkutTermLimit() {
      if (this.policy.product_type !== 2 || !this.berkutMaxEndDate) return false
      if (!this.isTermAfterBerkutMax(this.policy.treaty.term, this.berkutMaxEndDate)) {
        const warning = this.policy.vehicle?.reduce((message, item) => {
          if (item?.podft?.success && item?.podft?.term_limited && item?.podft?.message) return item.podft.message
          return message
        }, '')
        if (warning) this.$notifyWarning({message: warning})
        return false
      }
      this.duration = null
      this.policy.treaty.term = ''
      this.policy.hasCalc = false
      this.$notifyWarning({message: this.berkutLimitedMessage(this.berkutMaxEndDate)})
      this.$nextTick(() => {
        this.policy.hasCalc = false
      })
      return true
    }
  },
  watch: {
    policy: {
      deep: true,
      handler() {
        let vehicle     = this.policy.vehicle.length
        let insureds    = this.policy.insureds.length
        const validated = OsgpoModule.Validator.insuredsVehiclesShow(insureds, vehicle)
        this.policy.insuredsShow      = validated.insuredsShow
        this.policy.vehicleShow       = validated.vehicleShow
        const insurerInsuredsLength   = this.policy.insurer && this.policy.insureds.length > 0
        this.policy.hasSave           = !!insurerInsuredsLength
        this.policy.hasVerify         = !!(insurerInsuredsLength && this.policy.vehicle.length > 0)
        if (this.errorClientKey) this.errorClientKey = []
        if (this.$route.query.global) this.hasGlobalVerify = this.verifyPolicy()
        this.validateImages     	    = OsgpoModule.Validator.uploadImages(this.policy);
		    this.validateDriversLicense   = OsgpoModule.Validator.driversLicense(this.policy);
      }
    },
    'policy.isDrive': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (!(this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name)) {
            this.policy.clientAddedList.unshift(this.policy.insurer.client.iin ?? this.policy.insurer.document?.number)
          }
          this.policy.insureds.unshift(this.policy.insurer)
        } else {
          if (this.policy.insurer) {
            if (!(this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name)) {
              let index = this.policy.clientAddedList.indexOf(this.policy.insurer.client.iin);
              if (!index) index = this.policy.clientAddedList.indexOf(this.policy.insurer.document?.number);
              this.policy.clientAddedList.splice(index, 1);
            }
            this.policy.insureds.shift()
          }
        }
      }
    },
    'policy.insureds': {
      deep: true,
      handler (newValue) {
        if (newValue) this.policy.hasPaid = false
        this.policy.hasCalc         = false
        this.policy.premium         = null
        this.policy.calculationDate = null
        let data = []
        Object.entries(newValue).forEach(([key, value]) => {
          data[key] = value.filter.resident
        });
        this.policy.residentRules.insured = data
      }
    },
    'policy.hasPaid': {
      deep: true,
      handler (newValue) {
        if (newValue) this.policy.paymentPhone = structuredClone(this.policy.insurer.client.phone)
      }
    },
    'policy.hasCalc': {
      deep: true,
      handler () {
        this.policy.hasOtpSend = false
        this.policy.hasOtpVerify = false
        this.otpCountdown = 0
      }
    },
    'policy.insurer': {
      deep: true,
      handler (newValue) {
        if (newValue && newValue.hasOwnProperty('filter')) {
          this.policy.residentRules.insurer = newValue.filter.resident
          if (!newValue.filter.person && this.policy.insureds.length === 0) {
            const headers = {
              'resident': true,
              'person': false,
              'verify': true,
              'esbd_id': 2,
              'step': 4
            }
            this.loaded = true
            axios.post('/api/client/get', headers)
                .then(res => {
                  if (res.data.length > 0) {
                    let temp = structuredClone(res.data[0])
                    temp['client']['name'] = temp['client']['title']
                    temp['driver'] = {
                      'age_experience_id': 2,
                      'experience': false,
                      'pensioner': false,
                      'age': 0
                    }
                    temp['class'] = {
                      'class':    3,
                      'class_id': 5
                    }
                    temp['location']['country_id'] = 1
                    this.policy.insureds.push(temp)
                  } else {
                    this.$notifyError(res.data)
                  }
                  this.loading = false
                })
                .catch(err => {
                  this.$notifyError(err)
                  this.loading = false
                })
                .finally(() => this.loaded = false)
          }
        }
      }
    },
    'policy.vehicle': {
      deep: true,
      handler (newValue) {
        if (newValue)
          this.policy.hasPaid         = false
        this.policy.hasCalc         = false
        this.policy.premium         = null
        this.policy.calculationDate = null
        let data = []
        Object.entries(newValue).forEach(([key, value]) => {
          data[key] = value.verify
        });
        this.policy.residentRules.vehicle = data
      }
    },
    'policy.residentRules': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          let wayBill = false
          this.policy.insureds.forEach((item, key) => {
            if (item.client.hasOwnProperty('esbd_id') && item.client.esbd_id === 2) {
              wayBill = key
            }
          })
          const check = OsgpoModule.Validator.checkResidentRules(newValue, this.policy.product_type, wayBill)
          this.policy.residentRulesError = check ?? null
        }
      }
    },
    'policy.manager': {
      immediate: true,
      handler(val) {
        if (val) {
          this.policy.agent = null
          this.dictionaries.loading.agents = true
          const headers = { id: val, product: this.policy.product }
          axios.post('/api/dictionaries/order/agents',  headers)
              .then(res => {
                if (res.data.result && res.data.data) this.dictionaries.agents = res.data.data
                if (this.$user.role === 4) {
                  if (this.dictionaries.agents.length) {
                    this.policy.agent = this.$user.id
                    this.dictionaries.disabled.agent = true
                  }
                }
              })
              .catch(err => this.$notifyError({message: err?.response?.data?.message ?? err.message}))
              .finally(() => {this.dictionaries.loading.agents = false})
        } else {
          this.dictionaries.agents = []
        }
      }
    },
    'policy.treaty': {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.policy.hasPaid = false
        this.policy.hasCalc = false
        this.policy.premium = null
        this.policy.calculationDate = null
      }
    },
    'policy.treaty.term': {
      immediate: true,
      handler(newValue) {
        if (this.duration && this.calculateEndDate(this.policy.treaty.date, this.duration) !== newValue && this.policy.product_type === 2) {
          this.duration = null
        }
        if (this.policy.product_type === 2 && this.berkutMaxEndDate && this.isTermAfterBerkutMax(newValue, this.berkutMaxEndDate)) {
          this.duration = null
          this.policy.treaty.term = ''
          this.policy.hasCalc = false
          this.$notifyWarning({message: this.berkutLimitedMessage(this.berkutMaxEndDate)})
        }
      }
    },
    'policy.treaty.date': {
      immediate: true,
      handler(newValue) {
        if (this.duration && this.policy.product_type === 2) this.policy.treaty.term = this.calculateEndDate(newValue, this.duration)
      }
    },
    'policy.product_type': {
      immediate: true,
      handler(val) {
        this.berkutMaxEndDate = null
        if (val) this.getProductNameByType(val)
      }
    },
    vehicleIdentity() {
      this.berkutMaxEndDate = null
    },
    '$route.query.draft': {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.policy = OsgpoModule.Policy.empty(this.today, 'OGPO_WEB_EA')
        }
        this.policy.apc = this.$user.apc ?? null
        if (newValue) {
          this.getIp()
              .then(res => {this.policy.ip = res.data.ip})
              .catch(() => {confirm(`Ошибка загрузки продукта`) ? location.reload() : location.reload()});
        }
      }
    },
    '$route.query.query': {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.policy = OsgpoModule.Policy.empty(this.today, 'OGPO_WEB_EA')
        }
        this.policy.apc = this.$user.apc ?? null
        this.getIp()
            .then(res => {this.policy.ip = res.data.ip})
            .catch(() => {confirm(`Ошибка загрузки продукта`) ? location.reload() : location.reload()});
      }
    },
    '$route.query.product': {
      immediate: true,
      handler(newValue) {
        if (newValue === 'undefined' || !newValue) this.policy = OsgpoModule.Policy.empty(this.today, 'OGPO_WEB_EA')
        if (newValue && Number(newValue) > 2) this.$router.replace({path: 'not-found'})
        if (newValue) this.policy.product_type = Number(newValue)
        this.policy.apc = this.$user.apc ?? null
        setTimeout(() => {this.getProductNameByType(newValue === 'undefined' || Number(newValue) > 2 ? 1 : newValue)}, 10)
      }
    },
    duration: {
      immediate: true,
      handler(newValue) {
        if (newValue && this.policy.product_type === 2) {
          this.policy.treaty.term = this.calculateEndDate(this.policy.treaty.date, newValue)
        }
      }
    },
    getUser: {
      immediate: true,
      handler(newValue) {
        if (newValue && !newValue.hasTerminal && permissions.groupSale().includes(newValue.role) && newValue.role !== 0) {
          setTimeout(() => {
            new bootstrap.Modal('#alertModal', {}).show()
          }, 150)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>